import { queryOptions, useQuery } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/** Retired style numbers and variant SKUs of one product, newest first (at most 200). */
export function skuHistoryQueryOptions(productId: string) {
  return queryOptions({
    queryKey: productKeys.skuHistory(productId),
    queryFn: () => productsApi.skuHistory(productId),
  });
}

export function useSkuHistory(productId: string, enabled = true) {
  return useQuery({ ...skuHistoryQueryOptions(productId), enabled });
}
